export function thousandFormatter(value) {
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

const formatPhoneNumber = (inputNumber) => {
  let formattedNumber = '';

  if (inputNumber.length === 1)
    formattedNumber = `+7 (${inputNumber.substring(0, 4)}`;

  if (inputNumber.length >= 2)
    formattedNumber = `+7 (${inputNumber.substring(1, 4)}`;

  if (inputNumber.length > 3)
    formattedNumber += `) ${inputNumber.substring(4, 7)}`;

  if (inputNumber.length > 6)
    formattedNumber += ` ${inputNumber.substring(7, 9)}`;

  if (inputNumber.length > 8)
    formattedNumber += ` ${inputNumber.substring(9, 11)}`;

  return formattedNumber;
};

export const onHandlePhoneChange = (event, form, fieldId = null) => {
  const fieldName = fieldId !== null ? `phone_${fieldId}` : 'phone';
  const inputNumber = event.target.value.replace(/[^\d]/g, '');
  form.setFieldsValue({
    [fieldName]: formatPhoneNumber(inputNumber),
  });
};

export function phoneFormatterKeyDown(event, form, fieldId = null) {
  const fieldName = fieldId !== null ? `phone_${fieldId}` : 'phone';
  if (event.code === 'Backspace') {
    const inputNumber = event.target.value
      .replace(/[^\d]/g, '')
      .toString()
      .slice(0, -1);
    event.preventDefault();

    form.setFieldsValue({
      [fieldName]: formatPhoneNumber(inputNumber),
    });

    if (inputNumber.length === 1 && fieldId !== null) {
      event.preventDefault();

      form.setFieldsValue({
        [fieldName]: null,
      });
    }
  }
}
